import { render, staticRenderFns } from "./MedicalTeam.vue?vue&type=template&id=d51228c8"
import script from "./MedicalTeam.vue?vue&type=script&lang=js"
export * from "./MedicalTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports